import { IconName } from '@infotech-soe/erp-ui-kit';
import { ActionProcessMode } from '@infotech-soe/metaschema';

import {
  BuiltinCaptionType,
  Caption,
  CaptionType,
} from '../../../models/caption/Caption';
import { DocLinksMode } from '../../../models/docLinks/docLinks';
import { ClientContext } from '../../context/IContextService';
import { UserInteractor, UserInteractorType } from '../UserInteractor';

import CategoryCommand from './CategoryCommand';

class InputDocsCommand extends CategoryCommand<void | Record<string, any>> {
  public isAvailable(context: ClientContext): boolean {
    const id = context.get('Id');
    if (id === undefined) {
      return false;
    }
    const selected = context.get('SelectedIds');
    return (
      context.get('InParams')?.linksGraph?.mode !== DocLinksMode.SINGLE &&
      (!selected ||
        selected.length === 0 ||
        (selected.length === 1 && selected[0] === id))
    );
  }

  public async getCaption(): Promise<Caption> {
    return {
      type: CaptionType.BUILT_IN,
      caption: BuiltinCaptionType.INPUT_DOCS,
    };
  }

  public getIcon(): IconName {
    return 'doclinks-in';
  }

  public async getUserInteractor(): Promise<UserInteractor> {
    return {
      type: UserInteractorType.INPUT_DOCS,
    };
  }

  public getProcessMode(): ActionProcessMode {
    return 'Current';
  }

  public getName(): string {
    return 'InputDocs';
  }
}

export default InputDocsCommand;
